import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { ETopMatchesLayoutType } from 'interfaces/sportsbook-configs';
import { GlobalIcon } from 'components/GlobalIcon';
import { NavigationCollapse } from 'components/NavigationCollapse';
import { SportRegionGameListSkeleton } from 'components/UI/Skeletons/SportRegionGameListSkeleton';
import './index.less';

export const TopMatchesCompactMenuSkeleton = (): ReactElement => {
  const { t } = useTranslation();

  if (
    isMobile() ||
    SpringConfigs.TOP_MATCHES_LAYOUT === ETopMatchesLayoutType.compact
  ) {
    return (
      <div className="topMatchesCompactMenuSkeleton">
        <SportRegionGameListSkeleton includeCollapse hideMargin />
      </div>
    );
  }

  return (
    <NavigationCollapse
      key="topMatches"
      title={t('sportsbook.topMatches')}
      icon={
        <GlobalIcon
          lib="sports"
          name="topMatches"
          size={EIconSize._24}
          className="text-color"
        />
      }
      wrapperClassName="sportsList__sport"
      headerClassName="sportsList__sport__header topMatches__header"
    />
  );
};
